import { Box, Card } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Slogans from "./Slogans";

export default function LayoutAuth() {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          position: "relative",
          width: "calc(100% - 2rem)",
          minHeight: "50vh",
          m: 2,
          pt: 6,
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { primary, warning },
          }) =>
            `${linearGradient(
              rgba(primary.dark, 0.6),
              rgba(warning.dark, 0.6),
            )}`,
        }}
      >
        <Box
          component="video"
          autoPlay
          loop
          muted
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            zIndex: -1,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source
            type="video/mp4"
            src="https://video.wixstatic.com/video/d61553_7425240c15c8496bb8f486ebbfa248ff/1080p/mp4/file.mp4"
          />
        </Box>
        <Slogans />
      </Box>
      <Box mt={{ xs: -26, lg: -24 }} px={1} width="calc(100% - 2rem)" mx="auto">
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            <Card
              sx={({ zIndex }) => ({
                p: 3,
                zIndex: zIndex.appBar,
              })}
            >
              <Box
                sx={({ functions }) => ({
                  pb: 3,
                  display: "grid",
                  justifyItems: "center",
                  alignItems: "center",
                  height: functions.pxToRem(100),
                })}
              >
                <img
                  src="images/logo-vidlet-butterfly.png"
                  alt="vidlet main logo with text and butterfly"
                />
              </Box>
              <Outlet />
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
}
